import {useGlobal} from "../../contexts/GlobalContext";


export default function SideNavbarLink({href, text, icon}) {
    const Icon = icon;
    const {isSideBarShow, setSideBarShow, activeSite, setActiveSite, isMobile} = useGlobal()

    const textShow = () => isSideBarShow ? "sidenav-text-show" : "sidenav-text-hide"

    const onClick = (href) => {
        setActiveSite(href)
        if (isMobile) setSideBarShow(false)
    }

    return (
        <div className={"pt-2"}>
            <a className={`${href === activeSite ? "sidenav-active" : ""} d-inline`} href={`#/${href}`}
               onClick={() => onClick(href)}><Icon/>
                {isSideBarShow && <span className={textShow()}> &nbsp; {text} </span>}
            </a>
        </div>

    );
}


